// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3_FXP","Div":"CustomFadeBox_Div__3lNQq","LargeDiv":"CustomFadeBox_LargeDiv__2oTXZ"};